module.exports = __webpack_public_path__ + "static/media/headerkw.1ad748da.png";